var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VDataTable',{attrs:{"items":_vm.data,"headers":_vm.headers},on:{"click:row":_vm.showUserDetail},scopedSlots:_vm._u([{key:"item.application_id",fn:function(ref){
var value = ref.value;
return [_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.$router.push({name: 'ApplicationShowPage', params: { id: value }})}}},[_vm._v(_vm._s(value))])]}},{key:"item.visit_at",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm.moment(value).format("YYYY-MM-DD"))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }